/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SunflowerUserMenuStudentQueryVariables = {
    numberOfClasses: number;
    topN?: number | null | undefined;
    classId?: string | null | undefined;
    fetchLeaderboardModalData: boolean;
};
export type SunflowerUserMenuStudentQueryResponse = {
    readonly viewer: {
        readonly profile: {
            readonly __typename: "Student";
            readonly classes: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly hasEnabledLeaderboard: boolean;
                    };
                }>;
            };
            readonly " $fragmentRefs": FragmentRefs<"Leaderboard_student" | "LeaderboardModal_student">;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
        readonly " $fragmentRefs": FragmentRefs<"SunflowerUserMenu_UserInfo_viewer">;
    };
};
export type SunflowerUserMenuStudentQuery = {
    readonly response: SunflowerUserMenuStudentQueryResponse;
    readonly variables: SunflowerUserMenuStudentQueryVariables;
};



/*
query SunflowerUserMenuStudentQuery(
  $numberOfClasses: Int!
  $classId: ID
  $fetchLeaderboardModalData: Boolean!
) {
  viewer {
    ...SunflowerUserMenu_UserInfo_viewer_1MWt7w
    profile {
      __typename
      ... on Student {
        ...Leaderboard_student_1lMob3
        ...LeaderboardModal_student_5N7ZT
        classes(first: $numberOfClasses) {
          edges {
            node {
              id
              hasEnabledLeaderboard
            }
          }
        }
      }
      ... on Node {
        __isNode: __typename
        id
      }
      ... on Teacher {
        id
      }
    }
    id
  }
}

fragment LeaderboardModal_student_5N7ZT on Student {
  id
  leaderboard @include(if: $fetchLeaderboardModalData) {
    currentWeek(classId: $classId) {
      points
      rank
      name
      avatarUrl
      studentId
    }
    previousWeek(classId: $classId) {
      points
      rank
      name
      avatarUrl
      studentId
    }
  }
  classes(first: $numberOfClasses) {
    edges {
      node {
        hasEnabledLeaderboard
        id
      }
    }
  }
  leaderboardClass {
    class {
      title
      displayName
      id
    }
  }
}

fragment Leaderboard_student_1lMob3 on Student {
  id
  user {
    avatar
    firstName
    lastName
    points {
      current
    }
    id
  }
  classes(first: $numberOfClasses) {
    edges {
      node {
        hasEnabledLeaderboard
        displayName
        id
        title
      }
    }
  }
}

fragment SunflowerUserMenu_UserInfo_viewer_1MWt7w on User {
  avatar
  firstName
  lastName
  profile {
    __typename
    ... on Student {
      school {
        title
        id
      }
      classes(first: $numberOfClasses) {
        edges {
          node {
            id
            title
            displayName
            hasEnabledLeaderboard
          }
        }
      }
      lanternStudent {
        selfReportedGrade {
          id
          title
        }
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
    ... on Teacher {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "classId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchLeaderboardModalData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numberOfClasses"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topN"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "numberOfClasses"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasEnabledLeaderboard",
  "storageKey": null
},
v8 = {
  "kind": "Variable",
  "name": "numberOfClasses",
  "variableName": "numberOfClasses"
},
v9 = {
  "kind": "Variable",
  "name": "classId",
  "variableName": "classId"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatar",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = [
  (v9/*: any*/)
],
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "points",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rank",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "avatarUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "studentId",
    "storageKey": null
  }
],
v17 = [
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SunflowerUserMenuStudentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "ClassConnection",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClassEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Class",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "fetchLeaderboard",
                        "value": false
                      },
                      (v8/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "topN",
                        "variableName": "topN"
                      }
                    ],
                    "kind": "FragmentSpread",
                    "name": "Leaderboard_student"
                  },
                  {
                    "args": [
                      (v9/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "fetchLeaderboard",
                        "variableName": "fetchLeaderboardModalData"
                      },
                      (v8/*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "LeaderboardModal_student"
                  }
                ],
                "type": "Student",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": [
              (v8/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "SunflowerUserMenu_UserInfo_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SunflowerUserMenuStudentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "School",
                    "kind": "LinkedField",
                    "name": "school",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "ClassConnection",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClassEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Class",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LanternStudent",
                    "kind": "LinkedField",
                    "name": "lanternStudent",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LanternGrade",
                        "kind": "LinkedField",
                        "name": "selfReportedGrade",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PointsObject",
                        "kind": "LinkedField",
                        "name": "points",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "current",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LeaderboardClass",
                    "kind": "LinkedField",
                    "name": "leaderboardClass",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Class",
                        "kind": "LinkedField",
                        "name": "class",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "condition": "fetchLeaderboardModalData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Leaderboard",
                        "kind": "LinkedField",
                        "name": "leaderboard",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v15/*: any*/),
                            "concreteType": "CurrentWeekLeaderboardUser",
                            "kind": "LinkedField",
                            "name": "currentWeek",
                            "plural": true,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v15/*: any*/),
                            "concreteType": "LeaderboardUser",
                            "kind": "LinkedField",
                            "name": "previousWeek",
                            "plural": true,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "type": "Student",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v17/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              },
              {
                "kind": "InlineFragment",
                "selections": (v17/*: any*/),
                "type": "Teacher",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f2bf80419a4a8f0422c732652d2ffde1",
    "id": null,
    "metadata": {},
    "name": "SunflowerUserMenuStudentQuery",
    "operationKind": "query",
    "text": "query SunflowerUserMenuStudentQuery(\n  $numberOfClasses: Int!\n  $classId: ID\n  $fetchLeaderboardModalData: Boolean!\n) {\n  viewer {\n    ...SunflowerUserMenu_UserInfo_viewer_1MWt7w\n    profile {\n      __typename\n      ... on Student {\n        ...Leaderboard_student_1lMob3\n        ...LeaderboardModal_student_5N7ZT\n        classes(first: $numberOfClasses) {\n          edges {\n            node {\n              id\n              hasEnabledLeaderboard\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on Teacher {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment LeaderboardModal_student_5N7ZT on Student {\n  id\n  leaderboard @include(if: $fetchLeaderboardModalData) {\n    currentWeek(classId: $classId) {\n      points\n      rank\n      name\n      avatarUrl\n      studentId\n    }\n    previousWeek(classId: $classId) {\n      points\n      rank\n      name\n      avatarUrl\n      studentId\n    }\n  }\n  classes(first: $numberOfClasses) {\n    edges {\n      node {\n        hasEnabledLeaderboard\n        id\n      }\n    }\n  }\n  leaderboardClass {\n    class {\n      title\n      displayName\n      id\n    }\n  }\n}\n\nfragment Leaderboard_student_1lMob3 on Student {\n  id\n  user {\n    avatar\n    firstName\n    lastName\n    points {\n      current\n    }\n    id\n  }\n  classes(first: $numberOfClasses) {\n    edges {\n      node {\n        hasEnabledLeaderboard\n        displayName\n        id\n        title\n      }\n    }\n  }\n}\n\nfragment SunflowerUserMenu_UserInfo_viewer_1MWt7w on User {\n  avatar\n  firstName\n  lastName\n  profile {\n    __typename\n    ... on Student {\n      school {\n        title\n        id\n      }\n      classes(first: $numberOfClasses) {\n        edges {\n          node {\n            id\n            title\n            displayName\n            hasEnabledLeaderboard\n          }\n        }\n      }\n      lanternStudent {\n        selfReportedGrade {\n          id\n          title\n        }\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on Teacher {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b332799584a19986a78ab09f855b6cf8';
export default node;
